import React from 'react';
import { motion } from 'framer-motion';
import { FiDollarSign, FiClock, FiFileText, FiShield } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const features = [
  {
    icon: FiDollarSign,
    title: "No Agent Commissions",
    description: "Keep 100% of your offer. We don't charge the standard 6-10% real estate agent fees."
  },
  {
    icon: FiClock,
    title: "Fast Closings",
    description: "We are cash buyers, meaning we don't rely on bank financing. We typically close in 14-30 days."
  },
  {
    icon: FiFileText,
    title: "We Pay Closing Costs",
    description: "We cover all standard closing costs, title fees, and recording fees. The offer we make is what you get."
  },
  {
    icon: FiShield,
    title: "Buy 'As-Is'",
    description: "Overgrown? Back taxes owed? Title issues? We buy land in any condition and handle the messy paperwork."
  }
];

export default function Features() {
  return (
    <section id="benefits" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-brand-600 font-semibold tracking-wide uppercase text-sm mb-2">Why Choose Us</h2>
          <h3 className="text-3xl md:text-4xl font-serif font-bold text-stone-900 mb-4">A Better Way to Sell Your Land</h3>
          <p className="text-lg text-stone-600">
            Selling land through traditional real estate agents can take months or even years. We provide a streamlined, direct-buyer process designed to save you time and money.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              className="bg-stone-50 p-8 rounded-2xl hover:shadow-lg transition-shadow border border-stone-100"
            >
              <div className="w-14 h-14 bg-brand-100 rounded-xl flex items-center justify-center mb-6">
                <SafeIcon icon={feature.icon} className="text-2xl text-brand-600" />
              </div>
              <h4 className="text-xl font-bold text-stone-900 mb-3">{feature.title}</h4>
              <p className="text-stone-600 leading-relaxed">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}